module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.woff2?88d9d9416c58bde56378dc4439e3a144";